var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStep2X = function SvgStep2X(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 30,
    viewBox: "0 0 48 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.5C0 3.35786 3.35786 0 7.5 0H36.9984C39.2283 0 41.2742 1.23665 42.3108 3.211L47.0358 12.211C47.9526 13.9573 47.9526 16.0427 47.0358 17.789L42.3108 26.789C41.2742 28.7633 39.2283 30 36.9984 30H7.5C3.35786 30 0 26.6421 0 22.5V7.5Z",
    fill: "#1E5C59"
  })));
};
export { SvgStep2X as ReactComponent };
export default __webpack_public_path__ + "step@2x.svg";